import PropTypes from 'prop-types';

import { PERM } from '#/config/permissions';
import { ROUTES } from '#/config/routes';
import TabbedDetailCard from '#/modules/commonComponents/layout/TabbedDetailCard';
import { useCan } from '#/modules/infra/auth/useCan';
import PurchaseAmendmentCreateAction from '#/modules/srmMgmt/purchaseOrder/components/PurchaseAmendmentCreateAction';
import PurchaseOrderAmendmentsSection from '#/modules/srmMgmt/purchaseOrder/components/PurchaseOrderAmendmentsSection';
import PurchaseOrderPaymentPlanSection from '#/modules/srmMgmt/purchaseOrder/components/PurchaseOrderPaymentPlanSection';
import { PURCHASE_AMENDMENT_KIND } from '#/modules/srmMgmt/purchaseOrder/helper/purchaseAmendmentKinds';

import { canAmendMiscPurchaseOrder } from '../helper/miscPurchaseOrderStatus';

import MiscPurchaseOrderLinesSection from './MiscPurchaseOrderLinesSection';

/** 非庫存採購單沒有到貨排程與進貨單，只留明細、付款計畫與異動歷史。 */
const MiscPurchaseOrderDetailTabs = ({ detail, onRefetch }) => {
  const canUpdate = useCan(PERM.MISC_PURCHASE_ORDER_UPDATE);

  return (
    <TabbedDetailCard defaultValue="lines">
      <TabbedDetailCard.List>
        <TabbedDetailCard.Trigger value="lines">採購明細</TabbedDetailCard.Trigger>
        <TabbedDetailCard.Trigger value="paymentPlan">付款計畫</TabbedDetailCard.Trigger>
        <TabbedDetailCard.Trigger value="amendments">異動歷史</TabbedDetailCard.Trigger>
      </TabbedDetailCard.List>

      <TabbedDetailCard.Pane value="lines" title="採購明細">
        <MiscPurchaseOrderLinesSection lines={detail?.lines ?? []} />
      </TabbedDetailCard.Pane>

      <TabbedDetailCard.Pane value="paymentPlan" title="付款計畫">
        <PurchaseOrderPaymentPlanSection
          kind={PURCHASE_AMENDMENT_KIND.MISC_PURCHASE_ORDER}
          orderId={detail?.id}
        />
      </TabbedDetailCard.Pane>

      <TabbedDetailCard.Pane
        value="amendments"
        title="異動歷史"
        actions={(
          <PurchaseAmendmentCreateAction
            orderId={detail?.id}
            enabled={canUpdate && canAmendMiscPurchaseOrder(detail?.status)}
            amendments={detail?.amendments}
            createPath={ROUTES.miscPurchaseOrderAmendmentCreate}
            editPath={ROUTES.miscPurchaseOrderAmendmentEdit}
          />
        )}
      >
        <PurchaseOrderAmendmentsSection
          kind={PURCHASE_AMENDMENT_KIND.MISC_PURCHASE_ORDER}
          detail={detail}
          onRefetch={onRefetch}
        />
      </TabbedDetailCard.Pane>
    </TabbedDetailCard>
  );
};

MiscPurchaseOrderDetailTabs.propTypes = {
  detail: PropTypes.shape({
    id: PropTypes.string,
    status: PropTypes.string,
    lines: PropTypes.arrayOf(PropTypes.object),
    amendments: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
  onRefetch: PropTypes.func,
};

export default MiscPurchaseOrderDetailTabs;
